import React, { Component } from 'react';
import Hidden from '@material-ui/core/Hidden';
import Location from '@solvhealth/types/interfaces/Location';
import history from '../../core/history';
import MobileAddInsuranceController from './MobileAddInsuranceController';
import DesktopAddInsurance from './DesktopAddInsurance';
import { analyticsTrackEvent } from '../../core/analytics';
import { emptyFunction } from '../../core/util/function';
import { TOUCH_BACK, TOUCH_FRONT, TOUCH_SKIP_ALL_TOGETHER } from '../../constants/index';
import { getDefaultBreakpoint } from '../../core/util/device/screen';
import { OriginType } from '../../core/util/bookingFlowRoutingTypes';
import { ImageType } from '~/sagas/images';
import { AddInsuranceActions } from '~/routes/addInsurance';

type OwnProps = {
  passThrough?: string;
  clearData?: (...args: any[]) => any;
  addInsuranceFlow?: string;
  clearEditFlow?: (...args: any[]) => any;
  location: Location;
  origin: OriginType;
  isFamilyVisitActivatedInBookingWidget: boolean;
  primaryPatientFullName: string;
  handleFileChange: (
    imageType: ImageType,
    location: Location,
    afterChangeActions: AddInsuranceActions
  ) => any;
};

type Props = OwnProps & typeof AddInsurance.defaultProps;

class AddInsurance extends Component<Props> {
  static defaultProps = {
    clearData: emptyFunction,
  };

  componentWillUnmount = () => {
    const { clearData } = this.props;
    /* TODO: change this so that data doesn't reset on refresh
     * Ideally, if it's a refresh don't clear the data, and if
     * it is any other page navigation like back or submit clear
     * the data. Good luck!
     */
    clearData();
  };

  handleSkip = () => {
    const { addInsuranceFlow, clearEditFlow } = this.props;
    analyticsTrackEvent(TOUCH_SKIP_ALL_TOGETHER, { addInsuranceFlow });

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    clearEditFlow();
    history.push(this.props.passThrough);
  };

  handleTouch = (type: any) => () => {
    const { addInsuranceFlow } = this.props;
    analyticsTrackEvent(type, { addInsuranceFlow });
  };

  render = () => (
    <>
      <Hidden initialWidth={getDefaultBreakpoint()} xsDown>
        <DesktopAddInsurance
          handleSkip={this.handleSkip}
          onClickBack={this.handleTouch(TOUCH_BACK)}
          onClickFront={this.handleTouch(TOUCH_FRONT)}
          {...this.props}
        />
      </Hidden>

      <Hidden initialWidth={getDefaultBreakpoint()} smUp>
        <MobileAddInsuranceController
          handleSkip={this.handleSkip}
          onClickBack={this.handleTouch(TOUCH_BACK)}
          onClickFront={this.handleTouch(TOUCH_FRONT)}
          {...this.props}
        />
      </Hidden>
    </>
  );
}

export default AddInsurance;
